import React, { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Header from '../../components/Header';
import Container from '../../components/Container';
import { familyApi } from '../../services/family-api';
import { Loading } from '../../components/Loading';
import { Granted, Invite, Product } from '../../types/family';
import OwnerPage from './components/OwnerPage/OwnerPage';
import GrantedPage from './components/GrantedPage/GrantedPage';
import { Actions, Categories } from '../../types/gtm';
import environmentConfig from '../../config/environment-configs';

type OwnerInfoResponse = {
  name: string;
  maxGranted: number;
  currentInFamily: number;
  grantedList: Array<Granted>;
  invitedList: Array<Invite>;
  productList: Array<any>;
};

type UserOwnerInfo = {
  granted: Granted;
  owner: Granted;
  productList: Array<Product>;
};

const FamilyPage = () => {
  window.location.href = environmentConfig.MY_FAMILY_URL;

  const { user, logout } = useAuth();
  const [userType, setUserType] = useState<string>();
  const [labelType, setlabelType] = useState<string>();
  const [loading, setLoading] = useState<boolean>();
  const [ownerInfo, setOwnerInfo] = useState<OwnerInfoResponse>({
    name: '',
    maxGranted: 0,
    currentInFamily: 0,
    grantedList: [],
    invitedList: [],
    productList: [],
  });

  const history = useHistory();
  const redirectHome = async () => {
    history.push('/');
  };
  const getUserType = async () => {
    familyApi
      .get('/v2/fe/user/type')
      .then((response: AxiosResponse) => {
        if (response.status !== 200) {
          redirectHome();
        }

        const { type } = response.data || 'no-family';
        setUserType(type);
      })
      .catch(() => {
        redirectHome();
      });
  };

  const [userOwnerInfo, setUserOwnerInfo] = useState<UserOwnerInfo>({
    granted: {
      globoId: '',
      name: '',
      email: '',
      picture: '',
    },
    owner: {
      globoId: '',
      name: '',
      email: '',
      picture: '',
    },
    productList: [],
  });

  const getOwnerInfo = async () => {
    setLoading(true);
    familyApi
      .get('/v1/fe/user/family/owners')
      .then((response: AxiosResponse<OwnerInfoResponse>) => {
        setLoading(false);
        setOwnerInfo(response.data);

        if (response.data.currentInFamily === response.data.maxGranted) {
          window.dataLayer.push({
            event: 'customEventUserInteraction',
            event_category: Categories.FamilyOwner,
            event_action: Actions.FamilyComplete,
            event_label: 'Tela Inicial',
            bd_suser_code: user?.globoId,
          });
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getOwnerFromGranted = async () => {
    setLoading(true);
    familyApi
      .get('/v1/fe/user/granteds')
      .then((response: AxiosResponse<UserOwnerInfo>) => {
        setLoading(false);
        setUserOwnerInfo(response.data);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUserType();
  }, []);

  useEffect(() => {
    if (!userType) {
      return;
    }

    if (userType === 'owner') {
      setlabelType('Titular');
      getOwnerInfo();
    }

    if (userType === 'granted') {
      setlabelType('Dependente');
      getOwnerFromGranted();
    }

    const l = userType === 'owner' ? 'Titular' : 'Dependente';
    window.dataLayer.push({
      event: 'customEventUserInteraction',
      event_category: `${Categories.Family} - ${l}`,
      event_action: Actions.Pageview,
      bd_suser_code: user?.globoId,
    });

    if (
      userType === 'no-family' ||
      (userType !== 'owner' && userType !== 'granted')
    ) {
      redirectHome();
    }
  }, [userType]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Header
        screenMenu={`${Categories.Family} - ${labelType}`}
        user={user}
        onLogout={logout}
        showReturn
        onReturn={({ handleSmartReturn }) => {
          window.dataLayer.push({
            event: 'customEventUserInteraction',
            event_category: `${Categories.Family} - ${labelType}`,
            event_action: Actions.ClickBack,
            bd_suser_code: user?.globoId,
          });

          handleSmartReturn();
        }}
      />
      <Container>
        {userType === 'owner' ? (
          <OwnerPage
            user={user}
            userName={ownerInfo.name}
            maxGranted={ownerInfo.maxGranted}
            currentInFamily={ownerInfo.currentInFamily}
            productList={ownerInfo.productList}
            grantedList={ownerInfo.grantedList}
            invitedList={ownerInfo.invitedList}
            getOwnerInfo={getOwnerInfo}
          />
        ) : (
          ''
        )}
        {userType === 'granted' ? (
          <GrantedPage
            user={user}
            picture={userOwnerInfo.owner.picture}
            ownerId={userOwnerInfo.owner.globoId}
            ownerName={userOwnerInfo.owner.name}
            productList={userOwnerInfo.productList}
            grantedId={userOwnerInfo.granted.globoId}
          />
        ) : (
          ''
        )}
      </Container>
    </>
  );
};

export default FamilyPage;
